// extracted by mini-css-extract-plugin
module.exports = {"tabsContainer":"oOPqI","tabs":"_1Sd7h"};